import React, { useEffect } from 'react';
import Repository from 'repositories/Repository';
import { useStore, StoreTypes } from 'context';
import * as types from 'constants/actionTypes';
import { SplitType } from 'constants/splitType';

const { ExtendedResourceRepository } = Repository;
const SynopsisUpdate = ({children,synopsisInfo}) => {
    const { tab,list } = synopsisInfo;
    const [{ bookId }] = useStore(StoreTypes.books);
    const [{ splitType }, extendedContentDispatch] = useStore(
        StoreTypes.extendedContent
    );

    useEffect(()=>{
        // 寫入extendedContentStore - synopsisTab
        extendedContentDispatch({
            type: types.SET_EXTENDED_CONTENT_SYNOPSIS_TAB,
            payload: {
                synopsisTab : (tab - 1)
            }
        });
    },[extendedContentDispatch, tab]);

    useEffect(() => {
      if (splitType === SplitType.MANUAL_SPLIT) {
        Promise.all(
          list.map((lists) =>
            ExtendedResourceRepository.getManualSplitHtml({
              bookId,
              filename: lists.src,
            })
          )
        ).then((obj) => {
          extendedContentDispatch({
            type: types.SET_EXTENDED_CONTENT_SYNOPSIS_LIST,
            payload: {
              synopsisList: obj,
            },
          });
        });
      } else {
        Promise.all(
          list.map((lists) =>
            ExtendedResourceRepository.getJSONContent({
              bookId,
              pathName: lists.src,
            })
          )
        ).then((obj) => {
          // 寫入extendedContentStore - synopsisList
          extendedContentDispatch({
            type: types.SET_EXTENDED_CONTENT_SYNOPSIS_LIST,
            payload: {
              synopsisList: obj,
            },
          });
        });
      }
    }, [bookId, extendedContentDispatch, list, splitType]);

    return (
        <div>{children}</div>
    )
}

export default SynopsisUpdate;
